<!-- Match main app content: /assets uses EquipmentPage with px-4 pb-4; avoid extra pl-5 so wiki/items aligns -->
<template>
  <div class="w-full m-0">
    <div class="card w-full">
      <Tabs
        :value="activeTabValue"
        class="w-full"
        @update:value="onTabChange"
      >
        <TabList>
          <Tab
            v-for="tab in items"
            :key="tab.route"
            :value="tab.route"
          >
            <router-link
              v-if="tab.route"
              v-slot="{ href, navigate }"
              :to="tab.route"
              custom
            >
              <a
                v-ripple
                :href="href"
                class="flex items-center gap-2 text-inherit"
                @click="navigate"
              >
                <i :class="tab.icon" />
                <span>{{ tab.label }}</span>
              </a>
            </router-link>
          </Tab>
        </TabList>
      </Tabs>
      <div class="pt-2">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const items = computed(() => {
    const tabs = [
        {
            route: '/wiki/items',
            label: 'Wiki',
            icon: 'pi pi-book',
        },
    ];
    if (authStore.isSystemAdmin) {
        tabs.push({
            route: '/wiki/editor',
            label: 'Editor',
            icon: 'pi pi-table',
        });
        tabs.push({
            route: '/wiki/scrapers',
            label: 'Scrapers',
            icon: 'pi pi-cloud-download',
        });
        tabs.push({
            route: '/wiki/image-generator',
            label: 'Image generator',
            icon: 'pi pi-images',
        });
    }
    tabs.push({
        route: '/wiki/suppliers',
        label: 'Suppliers',
        icon: 'pi pi-truck',
    });
    return tabs;
});

/** Tab highlight: match route string (Tab value = tab.route). */
const activeTabValue = computed(() => {
    const path = route.path;
    if (path.startsWith('/wiki/suppliers')) {
        return '/wiki/suppliers';
    }
    if (path.startsWith('/wiki/editor')) {
        return '/wiki/editor';
    }
    if (path.startsWith('/wiki/scrapers')) {
        return '/wiki/scrapers';
    }
    if (path.startsWith('/wiki/image-generator')) {
        return '/wiki/image-generator';
    }
    if (path.startsWith('/wiki/import')) {
        return '/wiki/items';
    }
    return '/wiki/items';
});

const onTabChange = (value) => {
    if (typeof value === 'string' && value && value !== route.path) {
        router.push(value);
    }
};
</script>

<style scoped>
/* Component-specific styles can go here if needed */
</style>
